export default "__VITE_ASSET__B6VOs13I__"